/* eslint-disable */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.V2ItemsToUpdate = exports.V1ItemsToUpdate = exports.V1IdentityType = exports.V1GroupsSortBy = exports.UserAction = exports.TriggerRemindersToCreateGroupRequestMode = exports.SortOrder = exports.SocialIdentityType = exports.SettingsGroupsSortBy = exports.RoleInGroup = exports.RoleFilter = exports.Role = exports.RequestStatus = exports.ReportType = exports.RelationshipWithGroup = exports.RelationshipMembership = exports.ProtectedService = exports.PrivacyLevel = exports.OwnershipFilter = exports.NotificationType = exports.NotificationChannel = exports.MigrationType = exports.MembershipStatus = exports.MediaType = exports.ItemsFilter = exports.IdentityIdentityType = exports.GroupPrivacyLevel = exports.GroupApprovalStatus = exports.GroupAppKey = exports.GroupAccessRestrictionType = exports.CreateGroupsPolicy = exports.ContentType = exports.AuthorizedGroupCreators = exports.AccessRestrictionType = void 0;
var AccessRestrictionType;
(function (AccessRestrictionType) {
    AccessRestrictionType["UNKNOWN"] = "UNKNOWN";
    AccessRestrictionType["ADMIN_APPROVAL"] = "ADMIN_APPROVAL";
    AccessRestrictionType["PAID_PLANS"] = "PAID_PLANS";
    AccessRestrictionType["EVENTS"] = "EVENTS";
})(AccessRestrictionType = exports.AccessRestrictionType || (exports.AccessRestrictionType = {}));
var AuthorizedGroupCreators;
(function (AuthorizedGroupCreators) {
    AuthorizedGroupCreators["UNKNOWN_POLICY"] = "UNKNOWN_POLICY";
    AuthorizedGroupCreators["OWNER"] = "OWNER";
    AuthorizedGroupCreators["MEMBERS"] = "MEMBERS";
    AuthorizedGroupCreators["MEMBERS_WITH_APPROVAL"] = "MEMBERS_WITH_APPROVAL";
})(AuthorizedGroupCreators = exports.AuthorizedGroupCreators || (exports.AuthorizedGroupCreators = {}));
var ContentType;
(function (ContentType) {
    ContentType["PLAIN_TEXT"] = "PLAIN_TEXT";
    ContentType["DRAFTJS"] = "DRAFTJS";
})(ContentType = exports.ContentType || (exports.ContentType = {}));
var CreateGroupsPolicy;
(function (CreateGroupsPolicy) {
    CreateGroupsPolicy["ONLY_ME"] = "ONLY_ME";
    CreateGroupsPolicy["MEMBERS"] = "MEMBERS";
    CreateGroupsPolicy["MEMBERS_WITH_MY_APPROVAL"] = "MEMBERS_WITH_MY_APPROVAL";
})(CreateGroupsPolicy = exports.CreateGroupsPolicy || (exports.CreateGroupsPolicy = {}));
var GroupAccessRestrictionType;
(function (GroupAccessRestrictionType) {
    GroupAccessRestrictionType["ADMIN_APPROVAL"] = "ADMIN_APPROVAL";
    GroupAccessRestrictionType["PAID_PLANS"] = "PAID_PLANS";
    GroupAccessRestrictionType["EVENTS"] = "EVENTS";
})(GroupAccessRestrictionType = exports.GroupAccessRestrictionType || (exports.GroupAccessRestrictionType = {}));
var GroupAppKey;
(function (GroupAppKey) {
    GroupAppKey["MEMBERS_APP"] = "MEMBERS_APP";
    GroupAppKey["FEED_APP"] = "FEED_APP";
    GroupAppKey["ABOUT_APP"] = "ABOUT_APP";
    GroupAppKey["GALLERY_APP"] = "GALLERY_APP";
    GroupAppKey["EVENTS_APP"] = "EVENTS_APP";
    GroupAppKey["CUSTOM_APP"] = "CUSTOM_APP";
})(GroupAppKey = exports.GroupAppKey || (exports.GroupAppKey = {}));
var GroupApprovalStatus;
(function (GroupApprovalStatus) {
    GroupApprovalStatus["EMPTY"] = "EMPTY";
    GroupApprovalStatus["PENDING"] = "PENDING";
    GroupApprovalStatus["APPROVED"] = "APPROVED";
    GroupApprovalStatus["REJECTED"] = "REJECTED";
    GroupApprovalStatus["CANCELLED"] = "CANCELLED";
})(GroupApprovalStatus = exports.GroupApprovalStatus || (exports.GroupApprovalStatus = {}));
var GroupPrivacyLevel;
(function (GroupPrivacyLevel) {
    GroupPrivacyLevel["SECRET"] = "SECRET";
    GroupPrivacyLevel["PRIVATE"] = "PRIVATE";
    GroupPrivacyLevel["PUBLIC"] = "PUBLIC";
})(GroupPrivacyLevel = exports.GroupPrivacyLevel || (exports.GroupPrivacyLevel = {}));
var IdentityIdentityType;
(function (IdentityIdentityType) {
    IdentityIdentityType["USER"] = "USER";
    IdentityIdentityType["MEMBER"] = "MEMBER";
})(IdentityIdentityType = exports.IdentityIdentityType || (exports.IdentityIdentityType = {}));
var ItemsFilter;
(function (ItemsFilter) {
    ItemsFilter["BY_ID"] = "BY_ID";
    ItemsFilter["ALL_ITEMS"] = "ALL_ITEMS";
})(ItemsFilter = exports.ItemsFilter || (exports.ItemsFilter = {}));
var MediaType;
(function (MediaType) {
    MediaType["ATTACHMENT"] = "ATTACHMENT";
    MediaType["IMAGE"] = "IMAGE";
    MediaType["VIDEO"] = "VIDEO";
})(MediaType = exports.MediaType || (exports.MediaType = {}));
var MembershipStatus;
(function (MembershipStatus) {
    MembershipStatus["UNKNOWN_STATUS"] = "UNKNOWN_STATUS";
    MembershipStatus["JOINED"] = "JOINED";
    MembershipStatus["PENDING"] = "PENDING";
})(MembershipStatus = exports.MembershipStatus || (exports.MembershipStatus = {}));
var MigrationType;
(function (MigrationType) {
    MigrationType["TEST"] = "TEST";
    MigrationType["DEFAULT_SORT_BY_MIGRATION"] = "DEFAULT_SORT_BY_MIGRATION";
    MigrationType["SET_PROFILE_PRIVACY"] = "SET_PROFILE_PRIVACY";
    MigrationType["CLEAR_PRIVATE_MEMBER_FLAG"] = "CLEAR_PRIVATE_MEMBER_FLAG";
    MigrationType["ADD_EVENTS_TAB"] = "ADD_EVENTS_TAB";
})(MigrationType = exports.MigrationType || (exports.MigrationType = {}));
var NotificationChannel;
(function (NotificationChannel) {
    NotificationChannel["WEB"] = "WEB";
    NotificationChannel["MOBILE"] = "MOBILE";
    NotificationChannel["EMAIL"] = "EMAIL";
})(NotificationChannel = exports.NotificationChannel || (exports.NotificationChannel = {}));
var NotificationType;
(function (NotificationType) {
    NotificationType["ALL"] = "ALL";
    NotificationType["POST"] = "POST";
    NotificationType["COMMENT"] = "COMMENT";
    NotificationType["REACTION"] = "REACTION";
    NotificationType["MEMBERSHIP"] = "MEMBERSHIP";
    NotificationType["MEMBERS_JOIN"] = "MEMBERS_JOIN";
    NotificationType["GROUP_UPDATES"] = "GROUP_UPDATES";
    NotificationType["WEEKLY_DIGEST"] = "WEEKLY_DIGEST";
})(NotificationType = exports.NotificationType || (exports.NotificationType = {}));
var OwnershipFilter;
(function (OwnershipFilter) {
    OwnershipFilter["ALL"] = "ALL";
    OwnershipFilter["CURRENT_MEMBER"] = "CURRENT_MEMBER";
})(OwnershipFilter = exports.OwnershipFilter || (exports.OwnershipFilter = {}));
var PrivacyLevel;
(function (PrivacyLevel) {
    PrivacyLevel["UNKNOWN"] = "UNKNOWN";
    PrivacyLevel["PUBLIC"] = "PUBLIC";
    PrivacyLevel["PRIVATE"] = "PRIVATE";
    PrivacyLevel["SECRET"] = "SECRET";
})(PrivacyLevel = exports.PrivacyLevel || (exports.PrivacyLevel = {}));
var ProtectedService;
(function (ProtectedService) {
    ProtectedService["UNKNOWN_SERVICE"] = "UNKNOWN_SERVICE";
    ProtectedService["FEED"] = "FEED";
    ProtectedService["SHARED_GALLERY"] = "SHARED_GALLERY";
})(ProtectedService = exports.ProtectedService || (exports.ProtectedService = {}));
var RelationshipMembership;
(function (RelationshipMembership) {
    RelationshipMembership["UNKNOWN_MEMBERSHIP"] = "UNKNOWN_MEMBERSHIP";
    RelationshipMembership["NONE"] = "NONE";
    RelationshipMembership["JOINED"] = "JOINED";
    RelationshipMembership["PENDING"] = "PENDING";
})(RelationshipMembership = exports.RelationshipMembership || (exports.RelationshipMembership = {}));
var RelationshipWithGroup;
(function (RelationshipWithGroup) {
    RelationshipWithGroup["NONE"] = "NONE";
    RelationshipWithGroup["JOINED"] = "JOINED";
    RelationshipWithGroup["PENDING_APPROVAL"] = "PENDING_APPROVAL";
    RelationshipWithGroup["REJECTED_MEMBERSHIP"] = "REJECTED_MEMBERSHIP";
})(RelationshipWithGroup = exports.RelationshipWithGroup || (exports.RelationshipWithGroup = {}));
var ReportType;
(function (ReportType) {
    ReportType["UNWANTED_CONTENT"] = "UNWANTED_CONTENT";
    ReportType["HARASSMENT"] = "HARASSMENT";
    ReportType["INAPPROPRIATE_CONTENT"] = "INAPPROPRIATE_CONTENT";
    ReportType["HATE_SPEECH_OR_GRAPHIC"] = "HATE_SPEECH_OR_GRAPHIC";
    ReportType["OTHER"] = "OTHER";
    ReportType["UnwantedContent"] = "UnwantedContent";
    ReportType["Harrasment"] = "Harrasment";
    ReportType["InappropiateContent"] = "InappropiateContent";
    ReportType["HateSpeechOrGraphic"] = "HateSpeechOrGraphic";
})(ReportType = exports.ReportType || (exports.ReportType = {}));
var RequestStatus;
(function (RequestStatus) {
    RequestStatus["UNKNOWN_STATUS"] = "UNKNOWN_STATUS";
    RequestStatus["PENDING"] = "PENDING";
    RequestStatus["APPROVED"] = "APPROVED";
    RequestStatus["REJECTED"] = "REJECTED";
    RequestStatus["CANCELLED"] = "CANCELLED";
})(RequestStatus = exports.RequestStatus || (exports.RequestStatus = {}));
var Role;
(function (Role) {
    Role["UNKNOWN_ROLE"] = "UNKNOWN_ROLE";
    Role["MEMBER"] = "MEMBER";
    Role["ADMIN"] = "ADMIN";
})(Role = exports.Role || (exports.Role = {}));
var RoleFilter;
(function (RoleFilter) {
    RoleFilter["UNKNOWN"] = "UNKNOWN";
    RoleFilter["GROUP_MEMBER"] = "GROUP_MEMBER";
    RoleFilter["GROUP_ADMIN"] = "GROUP_ADMIN";
})(RoleFilter = exports.RoleFilter || (exports.RoleFilter = {}));
var RoleInGroup;
(function (RoleInGroup) {
    RoleInGroup["GROUP_ADMIN"] = "GROUP_ADMIN";
    RoleInGroup["GROUP_MEMBER"] = "GROUP_MEMBER";
    RoleInGroup["SITE_ADMIN"] = "SITE_ADMIN";
})(RoleInGroup = exports.RoleInGroup || (exports.RoleInGroup = {}));
var SettingsGroupsSortBy;
(function (SettingsGroupsSortBy) {
    SettingsGroupsSortBy["UNKNOWN"] = "UNKNOWN";
    SettingsGroupsSortBy["DEFAULT"] = "DEFAULT";
    SettingsGroupsSortBy["RECENT_ACTIVITY"] = "RECENT_ACTIVITY";
    SettingsGroupsSortBy["TITLE"] = "TITLE";
    SettingsGroupsSortBy["MEMBER_COUNT"] = "MEMBER_COUNT";
})(SettingsGroupsSortBy = exports.SettingsGroupsSortBy || (exports.SettingsGroupsSortBy = {}));
var SocialIdentityType;
(function (SocialIdentityType) {
    SocialIdentityType["ANONYMOUS"] = "ANONYMOUS";
    SocialIdentityType["MEMBER"] = "MEMBER";
    SocialIdentityType["USER"] = "USER";
    SocialIdentityType["EXTERNAL_APP"] = "EXTERNAL_APP";
})(SocialIdentityType = exports.SocialIdentityType || (exports.SocialIdentityType = {}));
var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder = exports.SortOrder || (exports.SortOrder = {}));
var TriggerRemindersToCreateGroupRequestMode;
(function (TriggerRemindersToCreateGroupRequestMode) {
    TriggerRemindersToCreateGroupRequestMode["TEST_MODE"] = "TEST_MODE";
    TriggerRemindersToCreateGroupRequestMode["PROD_MODE"] = "PROD_MODE";
})(TriggerRemindersToCreateGroupRequestMode = exports.TriggerRemindersToCreateGroupRequestMode || (exports.TriggerRemindersToCreateGroupRequestMode = {}));
var UserAction;
(function (UserAction) {
    UserAction["VIEW"] = "VIEW";
    UserAction["ADD_COMMENT"] = "ADD_COMMENT";
    UserAction["REACT"] = "REACT";
    UserAction["UNREACT"] = "UNREACT";
    UserAction["REPORT"] = "REPORT";
    UserAction["EDIT"] = "EDIT";
    UserAction["DELETE"] = "DELETE";
    UserAction["VIEW_REPORT"] = "VIEW_REPORT";
})(UserAction = exports.UserAction || (exports.UserAction = {}));
var V1GroupsSortBy;
(function (V1GroupsSortBy) {
    V1GroupsSortBy["RECENT_ACTIVITY"] = "RECENT_ACTIVITY";
    V1GroupsSortBy["NAME"] = "NAME";
    V1GroupsSortBy["MEMBERS_COUNT"] = "MEMBERS_COUNT";
})(V1GroupsSortBy = exports.V1GroupsSortBy || (exports.V1GroupsSortBy = {}));
var V1IdentityType;
(function (V1IdentityType) {
    V1IdentityType["VISITOR"] = "VISITOR";
    V1IdentityType["MEMBER"] = "MEMBER";
    V1IdentityType["USER"] = "USER";
    V1IdentityType["SERVICE"] = "SERVICE";
    V1IdentityType["EXTERNAL_APP"] = "EXTERNAL_APP";
})(V1IdentityType = exports.V1IdentityType || (exports.V1IdentityType = {}));
var V1ItemsToUpdate;
(function (V1ItemsToUpdate) {
    V1ItemsToUpdate["BY_ID"] = "BY_ID";
    V1ItemsToUpdate["ALL_ITEMS"] = "ALL_ITEMS";
})(V1ItemsToUpdate = exports.V1ItemsToUpdate || (exports.V1ItemsToUpdate = {}));
var V2ItemsToUpdate;
(function (V2ItemsToUpdate) {
    V2ItemsToUpdate["BY_ID"] = "BY_ID";
    V2ItemsToUpdate["ALL_ITEMS"] = "ALL_ITEMS";
})(V2ItemsToUpdate = exports.V2ItemsToUpdate || (exports.V2ItemsToUpdate = {}));
//# sourceMappingURL=types.js.map